﻿import { ArrowLeft } from "lucide-react";
import { Link , useNavigate } from "react-router-dom";
import { useT } from "@/lib/i18n";
import { toast } from "sonner";
import type { CreatePromotionRequest } from "@ticketnjoy/types";

import { DashboardPage } from "@/components/dashboard-page";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useCreatePromotionMutation } from "@/features/promotions/api";
import { PromotionForm } from "@/features/promotions/promotion-form";

export function NewPromotionPage() {
  const t = useT();
  const navigate = useNavigate();
  const mutation = useCreatePromotionMutation();

  const onSubmit = async (payload: CreatePromotionRequest) => {
    try {
      const p = await mutation.mutateAsync(payload);
      toast.success(t("promotions.createSuccess"));
      navigate(`/promotions/${p.id}`);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : t("common.unexpectedError"));
    }
  };

  return (
    <DashboardPage>
      <div className="mb-6">
        <Button variant="ghost" size="sm" asChild>
          <Link to="/promotions">
            <ArrowLeft className="me-1 h-4 w-4 rtl:-scale-x-100" /> {t("promotions.back")}
          </Link>
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>{t("promotions.newTitle")}</CardTitle>
          <CardDescription>{t("promotions.newDesc")}</CardDescription>
        </CardHeader>
        <CardContent>
          <PromotionForm
            mode="create"
            onSubmit={onSubmit}
            isSubmitting={mutation.isPending}
          />
        </CardContent>
      </Card>
    </DashboardPage>
  );
}
